import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import React, { ReactNode } from 'react'
import { PlusIcon, MinusIcon } from '@heroicons/react/20/solid'
import { useLocalStorageState } from 'ahooks'

type Props = {
  defaultOpen?: boolean
  name: string
  title: string | ReactNode
  description?: string | ReactNode
  children: ReactNode
  className?: string
  hasValue?: boolean
}

export function Section({ defaultOpen, name, title, description, hasValue, children, className }: Props) {
  const [open, setOpen] = useLocalStorageState<boolean>(`section-${name}`, { defaultValue: defaultOpen ?? false })
  return (
    <div className='w-full'>
      <button type='button' className='w-full flex items-center justify-between gap-3 py-2.5 pl-3 pr-4' onClick={() => setOpen(!open)} aria-label={`Toggle ${title}`}>
        <div className='flex items-center'>
          <span className={twMerge('w-[6px] h-[6px] rounded mr-2.5', hasValue ? 'bg-red-800' : 'bg-transparent')} />
          <span className='text-base md:text-sm font-medium'>{title}</span>
          {
            description && <span className='text-sm/6 ml-1.5 font-light'>({description})</span>
          }
        </div>
        {open ? <MinusIcon className='size-4' /> : <PlusIcon className='size-4' />}
      </button>
      <div className={twMerge('px-7 py-4 bg-white dark:bg-zinc-900', className, open ? 'block' : 'hidden')}>
        {children}
      </div>
    </div >
  )
}